import React from 'react';
import {
    Button,
    useUpdateMany,
    useRefresh,
    useNotify,
    useUnselectAll,
} from 'react-admin';
import CloseIcon from '@mui/icons-material/Close';

const DisableButton = (params) => {
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [updateMany, { loading }] = useUpdateMany(
        params.resource,
        params.selectedIds,
        { enabled: false },
        {
            onSuccess: () => {
                refresh();
                notify('Items enabled');
                unselectAll(params.resource);
            },
            onFailure: error =>
                notify('Error: items are not updated', 'warning'),
        },
    );

    return (
        <Button color="secondary" label="Disable" disabled={loading} onClick={updateMany}>
            <CloseIcon />
        </Button> 
    );
};

export default DisableButton;